/**
 * Created by Arison on 2018/11/6.
 */
import React from 'react';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import './ReleaseAssignmentPage.css'
import '../../style/css/app-gloal.css'
import moment from 'moment'
import {Input, Button, Icon, message} from 'antd';
import TargetSelect from "../../components/TargetSelect";
import {fetchPost, fetchGet,fetchPostObj} from '../../utils/fetchRequest';
import {_baseURL, API} from '../../configs/api.config';
import {isObjEmpty, getIntValue, getStrValue} from '../../utils/common';
import UploadEnclosure from 'components/UploadEnclosure'

import {Toast, DatePicker, List, Picker} from 'antd-mobile'
import {connect} from 'react-redux'

const {TextArea} = Input;
const nowTimeStamp = Date.now();
const now = new Date(nowTimeStamp);

/**
 * 发布作业
 * Created by Arison on 17:47.
 */
class ReleaseAssignmentPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: 'ReleaseAssignmentPage',
            fileList: [],
            targetList: [],
            targetCount: 0,
            targetData: [],
            endDate: '',//截止时间
            taskTitle: '',
            taskContent: '',
            courseList: [],
            courseValue: [],
        }
    }

    componentWillMount() {
        document.title = "发布作业";
    }

    componentWillUnmount() {
        Toast.hide()

        clearTimeout(this.backTask)
    }

    handleChange = (fileList) => {
        if (fileList) {
            this.setState({fileList})
        }

        /* this.state.data.notifyFiles.length = 0;
         for (let i = 0; i < fileList.length; i++) {
             if (fileList[i].status === "done") {
                 this.state.data.notifyFiles.push(fileList[i].response.data)
             }
         }*/
    }

    handleRemove = (file) => {
    }

    componentDidMount() {
        this.getOrganization();
        this.getSubjectList();
    }


    changeName = (e) => {
        this.setState({
            taskTitle: e.target.value
        })

    }

    changeContent = (e) => {
        this.setState({
            taskContent: e.target.value
        })
    }
    changeEndDateOk = (value) => {
        if (isObjEmpty(value)) {
            message.info("请选择日期");
            return
        }
    }

    changeEndDate = (value, dateString) => {
        this.setState({})
    }

    onTargetChange = (value, label, checkNodes, count) => {
        this.checkNodes = checkNodes
        this.setState({
            targetList: value,
            targetCount: count,
        });
    }

    commitAction = () => {
        const {taskTitle, taskContent, endDate, fileList, courseValue} = this.state

        if (isObjEmpty(taskTitle)) {
            Toast.fail("请输入作业名称");
            return;
        }
        if (taskTitle.length > 50) {
            Toast.fail('作业名称过长')
            return
        }

        if (isObjEmpty(taskContent)) {
            Toast.fail('请输入作业内容')
            return;
        }
        if (isObjEmpty(endDate)) {
            Toast.fail("请输入截止时间");
            return;
        }
        if (isObjEmpty(courseValue)) {
            Toast.fail("请选择作业科目");
            return;
        }
        if (isObjEmpty(this.checkNodes)) {
            Toast.fail("请选择抄送对象");
            return;
        }
        let personArrays = ''
        if (!isObjEmpty(this.checkNodes)) {
            /*this.checkNodes.forEach((node) => {
                personArrays.push(node.classId)
            })*/
            personArrays = this.checkNodes[0]
        }
        const fileUrls = []
        if (fileList) {
            fileList.forEach((value, index) => {
                fileUrls.push(value.picUrl)
            })
        }


        Toast.loading('正在发布...', 0)
        const params = {
            /*subjectId: courseValue[0],
            taskTitle: taskTitle,
            taskContext: taskContent,
            taskFiles: JSON.stringify(fileUrls),
            taskStatus: 1,
            startDate: now.format('yyyy-MM-dd hh:mm:ss'),
            endDate: moment(endDate).format('YYYY-MM-DD HH:mm:ss'),
            taskCreator: this.props.userInfo.user.userFunId,
            taskClassid: personArrays*/

            classz_name:personArrays.classzName,
            grade_name:personArrays.gradeName,
            task_classid:personArrays.classId,
            task_gradeid:personArrays.taskGradeid,

            task_title:taskTitle,
            task_context:taskContent,
            creator:this.props.userInfo.user.userName,
            task_files:JSON.stringify(fileUrls),
            task_status:1,
            create_date:now.format('yyyy-MM-dd hh:mm:ss'),
            start_date:now.format('yyyy-MM-dd hh:mm:ss'),
            end_date:moment(endDate).format('YYYY-MM-DD HH:mm:ss'),
            task_creator:this.props.userInfo.user.userFunId,
            subject_id:courseValue[0]

        }
        console.log(params)
        fetchPostObj(API.homeWorkAdd, params,{"Content-Type": 'application/json;charset=UTF-8'}).then((response) => {
            Toast.hide();
            if (response.success) {
                Toast.success("发布成功！", 1)
                this.initPageData()

                this.backTask = setTimeout(() => {
                    this.props.history.goBack()
                }, 1000)
            }
        }).catch((error) => {
            Toast.hide()

            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
        })
    }

    goListAction = () => {
        this.props.history.goBack();
    }

    onTargetFocus = (e) => {
        if (isObjEmpty(this.state.targetData)) {
            this.getOrganization()
        }
    }


    render() {
        const {targetCount, targetList, targetData, fileList, courseList, courseValue} = this.state
        const targetProps = {
            placeholder: '请选择抄送对象',
            targetData: targetData,
            targetValues: targetList,
            title: '抄送对象',
            targetCount: targetCount,
            onTargetChange: this.onTargetChange.bind(this),
            onTargetFocus: this.onTargetFocus.bind(this),
            multiple: false,
        }

        const defaultTargetProps = {
            targetData: [],
            targetValues: this.state.targetList,
            title: '抄送对象',
            targetCount: this.state.targetCount,
            onTargetChange: this.onTargetChange.bind(this),
            onTargetFocus: this.onTargetFocus.bind(this),
            multiple: false,
        }

        return <div className='common-column-layout' style={{paddingBottom: '40px'}}>
            <div className='gray-line'></div>
            {this.state.targetData.length > 0 ? <TargetSelect {...targetProps}/>
                : <TargetSelect {...defaultTargetProps}/>}
            <div className='gray-line'></div>
            <Picker data={courseList} title='选择科目' extra='请选择'
                    value={courseValue} onChange={this.handleCourseChange} cols={1}>
                <List.Item arrow="horizontal">选择科目</List.Item>
            </Picker>
            <div className='gray-line'></div>
            <input placeholder="请输入作业名称" defaultValue={this.state.taskTitle}
                   onChange={this.changeName}
                   className='titleInput'/>
            <div className='gray-line' style={{height: '1px'}}></div>
            <TextArea autosize={{minRows: 6, maxRows: 12}}
                      value={this.state.taskContent}
                      onChange={this.changeContent}
                      className='contentInput'
                      placeholder="请输入作业内容"/>
            <div className='gray-line'></div>
            <DatePicker
                value={this.state.endDate}
                locale={{
                    okText: '确定',
                    dismissText: '取消'
                }}
                onChange={date => this.setState({endDate: date})}>
                <List.Item arrow="horizontal">截止时间</List.Item>
            </DatePicker>
            <div className='gray-line'></div>
            <UploadEnclosure
                action={API.UPLOAD_FILE}
                fileList={fileList}
                count={1}
                multiple={false}
                beforeUpload={this.beforeUpload.bind(this)}
                handleChange={this.handleChange.bind(this)}
            />

            <Button type="primary" onClick={this.commitAction}
                    style={{margin: '35px 35px 16px', borderRadius: 30}}
                    className='commonButton'>发布作业</Button>

            {/*<span className='announce-release-history' onClick={this.goListAction}>历史发布</span>*/}
        </div>
    }

    beforeUpload = (file, fileList) => {

    }

    initPageData = () => {
        this.setState({
            fileList: [],
            targetList: [],
            targetCount: 0,
            targetData: [],
            endDate: '',//截止时间
            taskTitle: '',
            taskContent: '',
        })
    }

    handleCourseChange = (v) => {
        console.log(v)
        this.setState({courseValue: v})
    }

    getOrganization = () => {
        Toast.loading('', 0)

        fetchGet(API.GET_CLASS_LIST, {
            teacherId: this.props.userInfo.user.userFunId,
        }).then(response => {
            Toast.hide()
            const {targetData} = this.state
            targetData.length = 0
            if (response && response.data) {
                response.data.forEach((dataObj, data_index) => {
                    targetData.push({
                        classId: dataObj.clazzId,
                        classzName: dataObj.clazzName,
                        gradeName:dataObj.gradeName,
                        taskGradeid:dataObj.gradeId,
                    title: getStrValue(dataObj, 'gradeName') + getStrValue(dataObj, 'clazzName'),
                        value: `4-${data_index}` + getStrValue(dataObj, 'gradeName') + getStrValue(dataObj, 'clazzName'),
                        key: `4-${data_index}`,
                    })

                    /*const stusDOSArray = dataObj.studentDOS
                    if (!isObjEmpty(stusDOSArray)) {
                        const classData = []
                        stusDOSArray.forEach((stuObj, index) => {
                            if (stuObj) {
                                classData.push({
                                    title: getStrValue(stuObj, 'stuName'),
                                    userId: getIntValue(stuObj, 'stuId'),
                                    userPhone: getStrValue(stuObj, 'userPhone'),
                                    value: `2-${data_index}-${index}-` + getStrValue(stuObj, 'stuName'),
                                    key: `2-${data_index}-${index}`,
                                })
                            }
                        })

                        targetData.push({
                            title: dataObj.gradeName + dataObj.clazzName + '全体学生',
                            value: `2-${data_index}` + dataObj.gradeName + dataObj.clazzName + '全体学生',
                            key: `2-${data_index}`,
                            children: classData,
                        })
                    }*/
                })
            }
            this.setState({
                targetData,
            })
        }).catch(error => {
            Toast.hide()

            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
        })
    }

    getSubjectList() {
        // Toast.loading('', 0)

        fetchPost(API.SUBJECT_LIST, {
            teacherId: this.props.userInfo.user.userFunId,
            subjectStatus: 1
        }).then(response => {
            Toast.hide()
            const {courseList, courseValue} = this.state
            courseList.length = 0
            courseValue.length = 0

            let dataArray = response.data
            if (dataArray) {
                for (let i = 0; i < dataArray.length; i++) {
                    let dataObject = dataArray[i]
                    if (dataObject) {
                        let subjectBean = {}

                        subjectBean.label = getStrValue(dataObject, 'subjectName')
                        subjectBean.subjectId = getStrValue(dataObject, 'subjectId')
                        subjectBean.subjectName = getStrValue(dataObject, 'subjectName')
                        subjectBean.subjectStatus = getStrValue(dataObject, 'subjectStatus')
                        subjectBean.schoolId = getStrValue(dataObject, 'schoolId')
                        subjectBean.value = getStrValue(dataObject, 'subjectId')

                        courseList.push(subjectBean)
                    }
                }

                if (courseList.length > 0) {
                    courseValue.push(courseList[0].value)
                    this.setState({
                        courseList,
                        courseValue
                    })
                }
            }
        }).catch(error => {
            Toast.hide()

            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('获取科目异常', 2)
            }
        })
    }
}

let mapStateToProps = (state) => ({
    userInfo: {...state.redUserInfo},
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(ReleaseAssignmentPage)
